<template>
     <front-layout title="Ofertas de Emprego">
        <template #header>
          <!--   <div class="flex justify-between items-center">
                <h2 class="font-semibold text-xl lg:text-4xl text-gray-800 leading-tight">Ofertas de Emprego</h2>
                <Link :href="route('create.job')" class="border border-primary-900 text-primary-900 uppercase text-sm py-2 px-4 font-bold rounded-lg">Criar Oferta</Link>
            </div> -->
        </template>

        <div class="py-60 pb-20 bg-texture">
            <div class="container mx-auto px-4">
                <div class="flex flex-col lg:flex-row lg:space-x-8">
                    <div class="lg:w-[25vw] bg-white shadow-lg p-4 rounded-lg h-full">
                        <h3 class="text-xs font-bold uppercase mb-4">Filtrar por</h3>
                        <regions @distrito="getDistrito" @concelho="getConcelho" @freguesia="getFreguesia" ref="regions" v-if="renderComponent" />

                        <!-- categories -->
                        <div class="mt-4" v-if="categories.length">
                            <h3 class="form-label text-sm font-bold">Categoria</h3>

                            <select v-model="categoria" class="border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm w-full mt-1">
                                <option value="" disabled>Categoria</option>
                                <option v-for="category in categories" :value="category.name">{{ category.name }}</option>
                            </select>
                        </div>

                        <button @click.prevent="cleanFilter" class="text-violet-500 text-xs font-bold uppercase mt-2 float-right">Limpar</button>
                    </div>
                    <!-- jobs list -->
                    <div class="flex-auto grid md:grid-cols-2 lg:grid-cols-1 gap-4 mt-4 lg:mt-0 h-full" v-if="jobs.length">
                  
                        <div v-for="job in filterJobs" class="flex flex-col lg:flex-row bg-white overflow-hidden shadow-lg rounded-lg lg:hover:scale-105 hover:cursor-pointer transition-all relative group items-center">

                            <!-- media -->
                            <img v-if="job.category_id && job.category.image" class="grayscale group-hover:grayscale-0 h-full lg:w-60 inset-0 object-cover object-center" :src="'/storage/categories/' + job.category.image" alt="imagem categoria" @click.prevent="showJob(job.slug)" />

                            <!-- content -->
                            <div class="py-4 px-6 text-gray-800 flex flex-col">
                                <h3 class="font-semibold text-xl leading-tight group-hover:text-violet-500" @click.prevent="showJob(job.slug)">{{ job.title }}</h3>

                                <p class="text-sm text-gray-400 tracking-wide my-2">{{job.freguesia}} - {{ job.distrito }}</p>
                                <p class="text-sm text-violet-500 hover:underline" v-if="job.category_id">
                                    <button @click.prevent="filterCategory(job.category.name)">{{job.category.name}}</button></p>
                            </div>
                        </div>
                    </div>
                    <div v-else class="text-gray-400">
                            <em class="text-xl">sem ofertas</em>
                            <p><a :href="route('contactos')" class="text-violet-500 text-sm">Contacte-nos</a></p>
                        </div>
                </div>
            </div>
        </div>
    </front-layout>
</template>


<script>
    import { defineComponent } from 'vue'
    import FrontLayout from '@/Layouts/FrontLayout.vue'
    import { Head, Link } from '@inertiajs/inertia-vue3'
    import JetButton from '@/Jetstream/Button.vue'
    import Regions from '@/Components/RegionsComp.vue'
   

    export default defineComponent({
        components: {
            Head,
            Link,
            FrontLayout,
            JetButton,
            Regions
        },
        props: {
            canLogin: Boolean,
            canRegister: Boolean,
            laravelVersion: String,
            phpVersion: String,
            jobs: Array,
            categories: Array
        },
        data() {
            return {
                distrito: '',
                concelho: '',
                freguesia: '',
                renderComponent: true,
                categoria: ''
            }
        },
        computed: {
            filterJobs () {
                return this.jobs
                .filter(job => {
                    return job.distrito.toLowerCase().includes(this.distrito.toLowerCase())
                })
                .filter(job => {
                    return job.concelho.toLowerCase().includes(this.concelho.toLowerCase())
                })
                .filter(job => {
                    return job.freguesia.toLowerCase().includes(this.freguesia.toLowerCase())
                })
                .filter(job => {
                    return job.category.name.toLowerCase().includes(this.categoria.toLowerCase())
                })
            }
        },
        methods: {
            dateFormated(jobDate) {
                let date = new Date(jobDate)
                return date.toLocaleDateString()
            },
            showJob(job) {
                this.$inertia.get(route('show.job', job));
            },
            getDistrito(e) {
                this.distrito =  e
            },
            getConcelho(e) {
                this.concelho =  e
            },
            getFreguesia(e) {
                this.freguesia =  e
            },
            filterCategory(name) {
                this.categoria = name
            },
            cleanFilter() {
                this.renderComponent = false

                this.$nextTick(() => {
                  this.renderComponent = true
                })

                this.distrito = ''
                this.concelho = ''
                this.freguesia = ''
                this.categoria = ''
            }
        },
    })
</script>